<template lang="pug">
  .page.home
    main.is-flex.is-centered
      .columns.is-multiline
        .column.is-12-mobile.is-4
          .box
            h3.indicator.title.is-4.title-calendar-debt
              div Total de deuda:
              .has-text-weight-bold.has-text-debt-total
                | {{ monthSummary.total | toCurrency('MXN') }}

        .column.is-12-mobile.is-4
          .box
            h3.indicator.title.is-4.title-calendar-debt-expired
              div Total Vencido:
              .has-text-weight-bold.has-text-debt-expired
                | {{ monthSummary.expired | toCurrency('MXN') }}

        .column.is-12-mobile.is-4
          .box
            h3.indicator.title.is-4.title-calendar-debt-overcome
              div Por Vencer:
              .has-text-weight-bold.has-text-debt
                | {{ monthSummary.total - monthSummary.expired | toCurrency('MXN') }}

      .box
        app-calendar(
          :events="debtsEvents"
          :event-limit="2"
          @change:month="onChange"
        )
          template(
            slot="event-card"
            slot-scope="props"
          )
            router-link.debt.is-flex(
              :to="{ name: 'InvoiceDetail', params: { uuid: props.event.id } }"
            )
              span(
                :class="amountClass(props.event)"
              ) {{ props.event.voucherSeries }}-{{ props.event.voucherConsecutive }}
              span(
                :class="amountClass(props.event)"
              ) {{ props.event.debt | toCurrency(props.event.voucherCurrency) }}
</template>

<script>
import moment from 'moment';

export default {
  name: 'DebtsCalendar',
  middleware: 'empty',
  components: {
    AppCalendar: () => import(/* webpackChunkName: "app-calendar" */ '../../components/UI/AppCalendar.vue'),
  },
  data() {
    return {
      now: moment(),
      customStyleSheet: null,
      debtsEvents: [],
    };
  },
  computed: {
    amountClass() {
      return (event) => {
        const debtDate = moment(event.operation.expirationDate);

        return {
          'has-text-debt': debtDate > this.now,
          'has-text-debt-expired': debtDate < moment(this.now).subtract(1, 'days'),
          'has-text-debt-total': debtDate.format('YYYY-MM-DD') === this.now.format('YYYY-MM-DD'),
        };
      };
    },
    monthSummary() {
      const mxnDebts = this.debtsEvents.map((invoice) => {
        invoice.totalMxnAmount = invoice.debt;

        if (invoice.voucherCurrency !== 'MXN') {
          invoice.totalMxnAmount = invoice.debt * invoice.voucherExchangeRate;
        }

        return invoice;
      });

      const total = mxnDebts.reduce((accum, { totalMxnAmount }) => totalMxnAmount + accum, 0);
      const expired = mxnDebts
        .filter(event => moment(event.operation.expirationDate) < moment(this.now).subtract(1, 'days'))
        .reduce((accum, { totalMxnAmount }) => totalMxnAmount + accum, 0);

      return {
        total,
        expired,
      };
    },
  },
  methods: {
    async onChange(next, next2, { _d: date }) {
      const month = moment(date).month();
      const year = moment(date).year();

      await this.$store.dispatch('invoices/getDebtsInMonth', {
        month,
        year,
      });

      this.debtsEvents = this.$store.getters['invoices/debtsEvents'];
    },
  },
};
</script>

<style lang="stylus" scoped>
main.is-flex.is-centered
  flex-direction column

.columns
  width 100%
  margin 0

.box
.app-calendar
  width 100%

.user-name
  text-decoration underline
  padding 0 .5rem

.debt.is-flex
  justify-content space-between
  padding-bottom .25rem
  font-weight 600
</style>
